import { Component, ElementRef, OnInit, ViewChild, inject } from "@angular/core";
import { AuditDataService } from "@app/audit/services/audit-data.service";
import { TabModel } from "@models/generic/TabModels/TabModel";
import * as Highcharts from "highcharts/highcharts-gantt";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";

@Component({
    selector: "audit-planning",
    templateUrl: "./audit-planning.component.html",
    styleUrls: ["./audit-planning.component.scss"],
    imports: [CerrixLoaderComponent]
})
export class AuditPlanningComponent implements OnInit {
    private _ds = inject(AuditDataService);

    tab: TabModel;
    @ViewChild("chartContainer", { static: true }) chartContainer: ElementRef;

    async ngOnInit() {
        await this.createChart();
        this.tab.showLoader = false;
    }

    private async createChart() {
        Highcharts.ganttChart(this.chartContainer.nativeElement as HTMLElement, {
            title: {
                text: "Audit Planning",
            },

            credits: {
                enabled: false,
            },

            yAxis: {
                uniqueNames: false,
            },

            navigator: {
                enabled: true,
                series: {
                    type: "gantt",
                    pointWidth: 0.5,
                    pointPadding: 0.25,
                },
                yAxis: {
                    min: 0,
                    max: 3,
                    reversed: true,
                    categories: [],
                },
            },
            scrollbar: {
                enabled: true,
            },

            rangeSelector: {
                enabled: true,
                selected: 5,
            },

            series: [
                {
                    name: "Planning",
                    type: "gantt",
                    data: await this._ds.getPlanningData(),
                },
            ],
        });
    }
}
